/* global Hover */

import { eventChannel } from 'redux-saga';

/**
 * Create Event listeners for when a node is changed
 * @param {Object} tree - the segmentation tree
 * @returns {Object} EventListener state is changed according to the event
 */
const nodeChangedChannel = (tree) =>
  eventChannel((emit) => {
    tree.addEventListener('node_property_changed', emit);
    return () => tree.removeEventListener('node_property_changed', emit);
  });

/**
 * Create Event listeners for when a node is added
 * @param {Object} tree - the segmentation tree
 * @returns {Object} EventListener state is changed when a node is added to the tree
 */
const nodeAddedChannel = (tree) =>
  eventChannel((emit) => {
    tree.addEventListener('node_added', emit);
    return () => tree.removeEventListener('node_added', emit);
  });

/**
 * Create Event listeners for when a node is deleted
 * @param {Object} tree - the segmentation tree
 * @returns {Object} EventListener state is changed when a node is deleted from the tree
 */
const nodeRemovedChannel = (tree) =>
  eventChannel((emit) => {
    tree.addEventListener('node_removed', emit);
    return () => tree.removeEventListener('node_removed', emit);
  });

export default {
  nodeChangedChannel,
  nodeRemovedChannel,
  nodeAddedChannel,
};
